import { createAsyncThunk } from '@reduxjs/toolkit'
import { actions as LKModalActions } from '../shared/LKModal'
import { ThunkApi } from '../../store/index.d'
import { viewFile } from 'src/store/linkedFiles'
import { translateLkMessage } from './translate'

const downloadFile = (ID: number, src, extension: string) => {
  const link = document.createElement('a')
  link.download = `File${ID}.${extension}`
  link.href = src.url
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

interface DownloadRemoteAttributes {
  ID: number
  hash: string
  extension: string
}

export const downloadRemote = createAsyncThunk<void, DownloadRemoteAttributes, ThunkApi>(
  'DOWNLOAD_REMOTE',
  async ({ ID, hash, extension }, { dispatch }) => {
    try {
      const result = await dispatch(
        viewFile({
          FileID: ID,
          HashSum_FileID_: hash,
        }),
      )

      if (!viewFile.fulfilled.match(result)) {
        dispatch(LKModalActions.openError(translateLkMessage(result.payload as string)))
        return
      }

      const { payload: src } = result

      downloadFile(ID, src, extension)
    } catch (error) {
      LKModalActions.openError(error.Error.Message || error.Error.Text)
    }
  },
)
